/* QUESTIONSET DETAILS */
export const QUESTION_SET_FETCH_REQUEST = 'QUESTION_SET_FETCH_REQUEST';
export const QUESTION_SET_FETCH_SUCCESS = 'QUESTION_SET_FETCH_SUCCESS';
export const QUESTION_SET_FETCH_FAILURE = 'QUESTION_SET_FETCH_FAILURE';


